// extracted by mini-css-extract-plugin
export default {"Filter":"Filter_Filter__BUD3N"};